import { FC } from "react";
import ThankYouScreenWrapper, { ThankYouScreenProps } from "./ThankYouScreenWrapper.tsx";

const ThankYouScreenAddOn: FC<ThankYouScreenProps> = (props) => (
  <ThankYouScreenWrapper {...props} title="Thank you">
    <div>
      <div className="w-full mb-6">
        <p className="text-base leading-6 text-content-secondary">
          Your application to add the CFD product has been received.
        </p>
      </div>

      <div className="w-full p-4 bg-intent-info-5 border border-intent-info-4 rounded-lg">
        <p className="text-sm leading-5 text-intent-info-2 font-medium mb-2">
          Enable Options trading in the platform
        </p>
        <p className="text-sm leading-5 text-intent-info-1 mb-3">
          After your application for CFDs is approved you'll need to log in to the platform to enable Options trading.
        </p>
        <p className="text-sm leading-5 text-intent-info-1 mb-3">
          Go to Product Library, select Options, and tap Trade Options.
        </p>
        <p className="text-sm leading-5 text-intent-info-1">
          You can also open My Accounts and choose Options Trading.
        </p>
      </div>
    </div>
  </ThankYouScreenWrapper>
);

export default ThankYouScreenAddOn;
